/* eslint-disable */
import {
  getConexion,
  getConexionHeaders,
  postConexion,
  putConexion,
} from '../../conexion/Conexion';

export const getAllProviders = () => async () => {
  const providers = await getConexion('proveedor/getAllProveedor');
  return providers;
};

export const getAllProvidersHeaders = (id) => async () => {
  const providers = await getConexionHeaders('proveedor/getAllProveedor', id);
  return providers;
};

export const createProvider = async (objProvider: any): Promise<void> => {
  const providers = await postConexion('proveedor/saveProveedor', objProvider);
  return providers;
};

export const updateProvider = async (objProvider: any): Promise<void> => {
  const providers = await postConexion(
    'proveedor/updateProveedor',
    objProvider
  );
  return providers;
};

export const updateConfigProvider = async (objProvider: any): Promise<void> => {
  await postConexion('cash/saveSpread', objProvider);
};

export const changePasswordProvider = async (objUser: any): Promise<void> => {
  await postConexion('proveedor/changePass', objUser);
};
